function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
import { useMemo } from "react";
var buildStyle = function(theme) {
    var _font = theme.font, base = _font.base, color = _font.color, lineHeight = _font.lineHeight;
    return {
        'radiogroup-primitive-base': {
            fontFamily: base.family,
            fontStyle: 'normal',
            fontWeight: base.weight.regular,
            letterSpacing: 'normal',
            lineHeight: lineHeight.list,
            textAlign: 'left',
            textIndent: 0,
            textShadow: 'none',
            textTransform: 'none',
            boxSizing: 'border-box',
            clear: 'both',
            color: color.base,
            display: 'block',
            fontSize: base.size.s,
            listStyleType: 'none',
            margin: 0,
            outline: 0,
            padding: 0
        },
        'radiogroup-primitive-rtl': {
            textAlign: 'right',
            direction: 'rtl'
        }
    };
};
var useStyle = function(param) {
    var isRtl = param.isRtl;
    var builtStyles = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    return useMemo(function() {
        return _objectSpread({}, builtStyles === null || builtStyles === void 0 ? void 0 : builtStyles['radiogroup-primitive-base'], isRtl && (builtStyles === null || builtStyles === void 0 ? void 0 : builtStyles['radiogroup-primitive-rtl']));
    }, [
        builtStyles,
        isRtl
    ]);
};
export default useStyle;
